module.exports = __webpack_public_path__ + "static/miss_helsinki.0e136c11.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/brand-logos/images/miss_helsinki.svg
// module id = 166
// module chunks = 35783957827783 170326373320454